import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatReport,
  processReport,
  formatPreReport,
  processPreReport,
} from './utils';

const PREREPORT_URL = `${API_CONFIG.API}/node/prereport`;
const REPORT_URL = `${API_CONFIG.API}/node/report`;
const REPORT_BY_OP_URL = `${API_CONFIG.API}/node/operation?include=report&filter[uuid][value]=`;
const PREREPORT_BY_OP_URL = `${API_CONFIG.API}/node/operation?include=prereport&filter[uuid][value]=`;
const EMPLOYEE_URL = `${API_CONFIG.API}/node/employee`;
export default {
  savePreReport(report) {
    report.type = 'node--prereport';
    return base.http().post(`${PREREPORT_URL}`, formatPreReport(report))
      .then(res => processReport(res.data.data));
  },
  updatePreReport(report) {
    report.type = 'node--prereport';
    return base.http().patch(`${PREREPORT_URL}/${report.id}`, formatPreReport(report))
      .then(res => processReport(res.data.data));
  },
  saveReport(report) {
    report.type = 'node--report';
    return base.http().post(`${REPORT_URL}`, formatReport(report))
      .then(res => processReport(res.data.data));
  },
  updateReport(report) {
    report.type = 'node--report';
    return base.http().patch(`${REPORT_URL}/${report.id}`, formatReport(report))
      .then(res => processReport(res.data.data));
  },
  getEmployees() {
    return base.http().get(`${EMPLOYEE_URL}`);
  },
  getPreReportByOperationId(id) {
    return base.http().get(`${PREREPORT_BY_OP_URL}${id}`)
      .then((res) => {
        if ('included' in res.data) {
          return processPreReport(res.data.included[0]);
        }
        return {
          pr_comercial: '',
          pr_juridico: '',
          pr_financiero: '',
          pr_final: '',
          id: '',
        };
      });
  },
  getReportByOperationId(id) {
    return base.http().get(`${REPORT_BY_OP_URL}${id}`)
      .then((res) => {
        if ('included' in res.data) {
          return processReport(res.data.included[0]);
        }
        return {
          pr_comercial: '',
          pr_juridico: '',
          pr_financiero: '',
          pr_final: '',
          pr_riesgos: '',
          id: '',
        };
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/reports/service.js